module.exports = __webpack_public_path__ + "img/3.f9f7244b.png";